import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

import images from '../../../style/img/flag/images';

const CountryCards = props => {

    let firstPercentageLiteral = props.literals.L314;
    let secondPercentageLiteral = props.literals.L315;
    let thirdPercentageLiteral = props.literals.L316;
    let fourthPercentageLiteral = props.literals.L317;
    let fifthPercentageLiteral = props.literals.L318;
    let sixthPercentageLiteral = props.literals.L319;

    if (props.page == 'socialDialogue')
    {
        firstPercentageLiteral = props.literals.L20659;
        secondPercentageLiteral = props.literals.L20660;
        thirdPercentageLiteral = props.literals.L20661;
        fourthPercentageLiteral = props.literals.L20662;
    }

    const roundDataToText = (countryData, indicatorName, force, forceCountry) => {
        if (countryData.data[indicatorName] != undefined && countryData.data[indicatorName] != 0)
        {
            return Math.round(countryData.data[indicatorName])+"%";
        }
        else
        {
            if (force)
            {
                if (countryData.countryCode == forceCountry)
                {
                    return "20%";
                }
            }
            return "-";
        }
    }

    let firstPercentage = "";
    let secondPercentage = "";
    let thirdPercentage = "";
    let fourthPercentage = "";
    let fifthPercentage = "";
    let sixthPercentage = "";

    if(props.countryData.data !== undefined){
        if(props.page === 'socialDialogue'){
            let forceATValue = false;
            if (props.dataset == "19")
            {
                // For one of the indicators the value for Austria must be set to 20
                forceATValue = true;
            }
            firstPercentage = roundDataToText(props.countryData, "indicator1");
            secondPercentage = roundDataToText(props.countryData, "indicator2", forceATValue, "AT");
            thirdPercentage = roundDataToText(props.countryData, "indicator3");
            fourthPercentage = roundDataToText(props.countryData, "indicator4");
        }else{
            firstPercentage = roundDataToText(props.countryData, "Job satisfaction");
            secondPercentage = roundDataToText(props.countryData, "Health affected by work");
            thirdPercentage = roundDataToText(props.countryData, "Health problem in the last 12 months");
            fourthPercentage = roundDataToText(props.countryData, "More than 15 days of absence");
            fifthPercentage = roundDataToText(props.countryData, "Sick at working");
            sixthPercentage = roundDataToText(props.countryData, "Be able to do current job until 60 years old");
        }
    }

    let downloadReport = "";
    let healthPerceptionExtraList01 = "";
    let healthPerceptionExtraList02 = "";
    if(props.page === 'socialDialogue'){
        if(props.countryData.countryCode != 'IS' && props.countryData.countryCode != 'NO' && props.countryData.countryCode != 'CH'){
            downloadReport = (
                <p className="download-report">
                    <a href={"/osh-barometer/osh-steering/social-dialogue/Social_Dialogue_"+props.countryData.countryName+".pdf"} className="download-pdf" target="_blank">
                        {ReactHtmlParser(props.literals.L20637)}
                    </a>
                </p>
            )
        }
    }else{
        healthPerceptionExtraList01 = (
                <li>
                    <div className="group-data">
                    <span className="country-data">{ fifthPercentage }</span>
                    {/* <span className="data-text">%</span> */}
                    </div>
                    <label>{ fifthPercentageLiteral }</label>
                </li>
        )
        healthPerceptionExtraList02 = (
                <li>
                    <div className="group-data">
                        <span className="country-data">{ sixthPercentage }</span>
                    </div>
                    <label>{ sixthPercentageLiteral } *</label>
                </li>
        )
    }
    
    return(
        <div className="chart--block">
            <header>
                <div className="flags--wrapper" >
                    <img src={`${images[props.countryData.countryCode.toLowerCase()]}`} alt={props.countryData.countryName} />
                </div>
                <div className="country-wrapper">
                    <h2 className="country ng-binding title-section main-color">{ props.countryData.countryName }</h2>
                    { downloadReport }
                </div>
            </header>
            <ul className="highlited-data-list">
                <li>                
                    <span className="country-data">{ firstPercentage }</span>
                    <label>{ firstPercentageLiteral }</label>
                </li>
                <li>                
                    <span className="country-data">{ secondPercentage }</span>
                    <label>{ secondPercentageLiteral }</label>
                </li>
                <li>                
                    <span className="country-data">{ thirdPercentage }</span>
                    <label>{ thirdPercentageLiteral }</label>
                </li>
                <li>                
                    <span className="country-data">{ fourthPercentage }</span>
                    <label>{ fourthPercentageLiteral }</label>
                </li>
                {healthPerceptionExtraList01}
                {healthPerceptionExtraList02}
            </ul>
        </div>
    )
}

export default CountryCards;

